var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessionalAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_6083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.584 21.0835H17.4173C16.4048 21.0835 15.584 21.9043 15.584 22.9168V41.2502C15.584 42.2627 16.4048 43.0835 17.4173 43.0835H26.584C27.5965 43.0835 28.4173 42.2627 28.4173 41.2502V22.9168C28.4173 21.9043 27.5965 21.0835 26.584 21.0835Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0827 32.0835H2.74935C1.73683 32.0835 0.916016 32.9043 0.916016 33.9168V41.2502C0.916016 42.2627 1.73683 43.0835 2.74935 43.0835H10.0827C11.0952 43.0835 11.916 42.2627 11.916 41.2502V33.9168C11.916 32.9043 11.0952 32.0835 10.0827 32.0835Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2507 37.5835H33.9173C32.9048 37.5835 32.084 38.4043 32.084 39.4168V41.2502C32.084 42.2627 32.9048 43.0835 33.9173 43.0835H41.2507C42.2632 43.0835 43.084 42.2627 43.084 41.2502V39.4168C43.084 38.4043 42.2632 37.5835 41.2507 37.5835Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7499 6.41662H28.2717C28.4654 6.4167 28.654 6.47813 28.8107 6.59208C28.9673 6.70604 29.0837 6.86667 29.1434 7.05094C29.2031 7.2352 29.2028 7.43362 29.1427 7.61774C29.0826 7.80186 28.9657 7.96221 28.8089 8.07578L25.8755 10.2043L27.6832 14.3586C27.7581 14.5339 27.7765 14.7282 27.7358 14.9145C27.6951 15.1008 27.5974 15.2697 27.4562 15.3978C27.315 15.5259 27.1373 15.6068 26.948 15.6292C26.7587 15.6516 26.5671 15.6144 26.3999 15.5228L21.9999 13.057L17.6164 15.5228C17.4492 15.6144 17.2576 15.6516 17.0682 15.6292C16.8789 15.6068 16.7013 15.5259 16.5601 15.3978C16.4188 15.2697 16.3211 15.1008 16.2804 14.9145C16.2397 14.7282 16.2581 14.5339 16.333 14.3586L18.1407 10.2043L15.2074 8.07578C15.0513 7.96286 14.9348 7.80366 14.8744 7.62078C14.814 7.43789 14.8127 7.24062 14.8707 7.05697C14.9288 6.87331 15.0432 6.71261 15.1977 6.59766C15.3523 6.48271 15.5391 6.41937 15.7317 6.41662H19.2499L21.1455 1.50328C21.2122 1.33055 21.3295 1.18204 21.4822 1.0773C21.6348 0.972563 21.8156 0.916504 22.0008 0.916504C22.1859 0.916504 22.3667 0.972563 22.5194 1.0773C22.672 1.18204 22.7894 1.33055 22.856 1.50328L24.7499 6.41662Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 28.4168C8.44171 28.4168 10.0833 26.7752 10.0833 24.7502C10.0833 22.7251 8.44171 21.0835 6.41667 21.0835C4.39162 21.0835 2.75 22.7251 2.75 24.7502C2.75 26.7752 4.39162 28.4168 6.41667 28.4168Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5827 33.9168C39.6077 33.9168 41.2493 32.2752 41.2493 30.2502C41.2493 28.2251 39.6077 26.5835 37.5827 26.5835C35.5576 26.5835 33.916 28.2251 33.916 30.2502C33.916 32.2752 35.5576 33.9168 37.5827 33.9168Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_6083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalAchievement);
export default __webpack_public_path__ + "static/media/professional_achievement.04dba9092cb24cff66974eee0af71bcf.svg";
export { ForwardRef as ReactComponent };